import { createApp,ref } from 'vue'
import 'normalize.css'
import '@/assets/css/reset.css'
import App from './App.vue'
import router from './router'
import store from './store'
import toastPlugin from './utils/toastPlugin'; // 引入Toast插件
import 'element-plus/theme-chalk/el-loading.css'
import 'element-plus/theme-chalk/el-message.css'
import 'element-plus/dist/index.css'; // 引入 Element Plus 的样式
const toasts = ref([]);


 const useToast = () => {
  const addToast = (message, type = 'success') => {
    toasts.value.push({ message, type });

    setTimeout(() => {
      toasts.value.shift();
    }, 3000);
  };

  return {
    toasts,
    addToast,
  };
};


const app=createApp(App).provide('useToast', useToast()).use(toastPlugin).use(store).use(router)
app.config.globalProperties.$Emessage =null;
app.mount('#app')
 
const globals = app.config.globalProperties
export { globals }
